import React from "react";
import styles from "./ContentWrapper.module.css";

const ContentWrapper = props => {

    const {style} = props;

    return (
        <div className={style === "80" ? styles.content_80 : styles.content}>{props.children}</div>
    )
}

export default ContentWrapper;